import {useFormContext} from '@yandex-delivery/form'
import {useCallback} from 'react'

import {experiments} from 'src/shared/config'
import {useBlocksVisibilityStatesContext} from 'src/shared/contexts'
import {OrderEventGoal, useFormUserEventHandler} from 'src/shared/hooks'

import type {DestinationPoint} from '../../shared/types'
import {useReturnPointModal} from './ReturnPointModal/hooks'
import {isValidPoint} from './utils/is-valid-point'

export function useVerticalOptions(vertical: string) {
  const {isReturnPointModalOpen, openReturnPointModal, closeReturnPointModalHandler, acceptReturnPointModalHandler} =
    useReturnPointModal()
  const {setInvisible, getIsVisible, setVisible} = useBlocksVisibilityStatesContext()
  const handleReachGoal = useFormUserEventHandler()

  const isAdditionalRequirementsVisible = getIsVisible('additionalRequirements')
  const toggleVisibilityHandler = useCallback(() => {
    isAdditionalRequirementsVisible ? setInvisible('additionalRequirements') : setVisible('additionalRequirements')
  }, [isAdditionalRequirementsVisible, setInvisible, setVisible])

  const destinationPoints: DestinationPoint[] = useFormContext().watch('destinationPoints') || []
  const isRouteChangeVisible = destinationPoints?.length > 1 && destinationPoints?.every(isValidPoint)

  const shouldShowAdditionalOptions = experiments.verticalsWithAdditionalOptions.includes(vertical)

  function handleRequirementChange() {
    handleReachGoal(OrderEventGoal.VerticalOptionsClick)
  }

  return {
    isAdditionalRequirementsVisible,
    toggleVisibilityHandler,
    openReturnPointModal,
    isRouteChangeVisible,
    isReturnPointModalOpen,
    acceptReturnPointModalHandler,
    closeReturnPointModalHandler,
    handleRequirementChange,
    shouldShowAdditionalOptions,
  } as const
}
